import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { fromEvent, Observable, Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'payment-error-screen',
  templateUrl: './payment-error-screen.component.html',
  styleUrls: ['./payment-error-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentErrorScreenComponent implements OnInit, OnDestroy {
  file_limit;
  screenWidth: number;
  buttonTitle;
  ispremuimuser = false;
  trial_period;
  max_admin_limit;
  admin_limit;
  min_admin_limit;
  buttonTextComapre;
  maxlimit;
  isAdminView = true;
  HeaderTitle;
  imagePath = '../../../../../assets/images/chosse-letter-date.png';

  subscription = new Subscription();

  // vault state object
  vaultStateObject;
  user;
  resizeObservable$: Observable<Event>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private vaultService: VaultStoreEffects,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PaymentErrorScreenComponent>,
    private loginService: LoginStoreEffects
  ) {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
        this.ngOnInit();
      })
    );
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.user = state.data;
          this.ngOnInit();
        }
      })
    );
  }

  closedialog() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    if (this.user?.freemium_limits?.trial_period) {
      this.trial_period = this.user?.freemium_limits?.trial_period;
      this.buttonTextComapre = `Try Free for ${this.trial_period} Days`;
    }
    if (this.data.limit_type == 'admin_limit') {
      this.max_admin_limit = this.user?.premium_limits?.admin_limit;
      this.min_admin_limit = this.user?.freemium_limits?.admin_limit;
      if (this.data.plan_type == 'premium') {
        if (this.user?.premium_limits) {
          this.ispremuimuser = true;
          this.admin_limit = this.user?.premium_limits?.admin_limit;
          this.HeaderTitle = `Need more than ${this.admin_limit} admins?`;
        }
        this.buttonTitle = 'Contact Us';
      } else {
        this.HeaderTitle = 'Want to add another admin?';

        this.ispremuimuser = false;
        this.maxlimit = this.user?.premium_limits?.admin_limit;
        if (this.user?.freemium_limits) {
          this.admin_limit = this.user?.freemium_limits?.admin_limit;
        }
        this.buttonTitle = `Try Free for ${this.trial_period} Days`;
      }
      this.imagePath = '../../../../../assets/images/admin-not-allowed-popup.png';
    } else if (this.data.limit_type == 'future_share') {
      this.HeaderTitle = 'Want to restrict access until a later date ?';

      if (
        this.user?.id != null &&
        this.user?.id != undefined &&
        this.user?.id == this.vaultStateObject?.userId &&
        this.vaultStateObject?.userId != null &&
        this.vaultStateObject?.userId != undefined
      ) {
        this.buttonTitle = `Try Free for ${this.trial_period} Days`;
      } else {
        this.buttonTitle = 'OK';
      }
      this.imagePath = '../../../../../assets/images/chosse-letter-date.png';
    } else if (this.data.limit_type == 'file_limit') {
      if (
        this.user?.id != null &&
        this.user?.id != undefined &&
        this.user?.id == this.vaultStateObject?.userId &&
        this.vaultStateObject?.userId != null &&
        this.vaultStateObject?.userId != undefined
      ) {
        this.isAdminView = true;
        this.file_limit = this.user?.freemium_limits?.file_limit;
      } else {
        this.buttonTitle = 'OK';
        this.isAdminView = false;
      }
      this.HeaderTitle = 'Need More Space?';
      this.imagePath = '../../../../../assets/images/need-morepspace.png';
    } else if (this.data.limit_type == 'admin_count') {
      this.buttonTitle = `Try Free for ${this.trial_period} Days`;

      this.HeaderTitle = 'Need more than 10 admins?';
      this.imagePath = '../../../../../assets/images/chosse-letter-date.png';
    } else if (this.data.limit_type == 'storage_limit') {
      this.buttonTitle = `Contact Us`;
      this.HeaderTitle = 'Need More Space?';
      this.imagePath = '../../../../../assets/images/need-morepspace.png';
      if (
        this.user?.id != null &&
        this.user?.id != undefined &&
        this.user?.id == this.vaultStateObject?.userId &&
        this.vaultStateObject?.userId != null &&
        this.vaultStateObject?.userId != undefined
      ) {
        this.isAdminView = true;
        if (this.data.plan_type != 'premium') {
          this.buttonTitle = `Try Free for ${this.trial_period} Days`;
        }
      } else {
        this.buttonTitle = 'OK';
        this.isAdminView = false;
      }
    } else if (this.data.limit_type == 'security_key') {
      this.buttonTitle = `OK`;
      this.HeaderTitle = 'Want to add a layer of security?';
      this.imagePath = '../../../../../assets/images/security-payment.png';
    } else if (this.data.limit_type == 'security_key_personal') {
      this.buttonTitle = `Try Free for ${this.trial_period} Days`;
      this.HeaderTitle = 'Want to add a layer of security?';
      this.imagePath = '../../../../../assets/images/security-payment.png';
    }
    // this.cd.detectChanges();
  }

  openPayment() {
    this.closedialog();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
